import { NgSwitch, NgSwitchCase } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { ICON_BANNER, ICON_PRODUCT } from 'src/app/shared/named-icons.config';
import { TrafficType } from '../../common.types';

@Component({
  selector: 'app-type-icon',
  templateUrl: 'type-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    InlineSVGModule,
    NgSwitch,
    NgSwitchCase,
  ]
})
export class TypeIconComponent {
  @Input()
  public type: TrafficType;

  public readonly trafficType = TrafficType;
  public readonly ICON_PRODUCT = ICON_PRODUCT;
  public readonly ICON_BANNER = ICON_BANNER;
}
